export const formatRM = (amount) => {
  const n = Number(amount || 0);
  return `RM${Number.isInteger(n) ? n : n.toFixed(2)}`;
};

export const formatQty = (qty) => `${Number(qty).toLocaleString("en-MY")} keping`;

/**
 * Address formatter for the PRINTED business card.
 * Malaysia -> country name is suppressed (Peninsular, Sabah, Sarawak, Labuan).
 */
export const formatMalaysianCardAddress = (addr = {}) => {
  const lines = [
    addr.line1,
    addr.line2,
    [addr.postcode, addr.city].filter(Boolean).join(" "),
    addr.state,
  ];
  return lines.map((l) => (l || "").trim()).filter(Boolean);
};

/** Singapore printed address retains "Singapore". */
export const formatSingaporeCardAddress = (addr = {}) => {
  const lines = [
    addr.line1,
    addr.line2,
    [addr.city, addr.postcode].filter(Boolean).join(" ").trim(),
    "Singapore",
  ];
  return lines.map((l) => (l || "").trim()).filter(Boolean);
};

/** Selects the correct country-specific formatter. Never generic. */
export const formatCardAddress = (addr = {}) => {
  if ((addr.country || "Malaysia") === "Singapore") {
    return formatSingaporeCardAddress(addr);
  }
  return formatMalaysianCardAddress(addr);
};

/**
 * Display formatter for the shipping address. `country = Malaysia` is retained
 * in the data model for shipping calculation but is never printed/displayed.
 * Singapore addresses keep "Singapore".
 */
export const formatShippingAddress = (addr = {}) => {
  if ((addr.country || "Malaysia") === "Singapore") return formatSingaporeCardAddress(addr);
  return formatMalaysianCardAddress(addr);
};
